export default "__VITE_ASSET__n5eL4pjK__"